import React from 'react';
import { NavLink } from 'react-router-dom';
import TopFixedMenu from './TopFixedMenu';
const MainMenu = ({ fixedMenuTopHeight }) => (
  <div className="header-section">
    <section className="section-header__hero-content row small-hidden">
      <div className="section-header__container column">
        <i className="fa fa-envelope header-icon"></i>
        <span className="section-header__text">info@chachanlath.in</span>
        <i className="fa fa-mobile header-icon"></i>
        <span className="section-header__text">+91-11 46461616, +91-11 46461617</span>
      </div>
      <div className="section-header__icon column">
        <a href="https://www.linkedin.com/company/chachan-&-lath/?originalSubdomain=in">
          <i className="fa fa-linkedin header-icon"></i>
        </a>
        <i className="fa fa-facebook header-icon"></i>
        <i className="fa fa-twitter header-icon"></i>
      </div>
    </section>
    <TopFixedMenu fixedMenuTopHeight={fixedMenuTopHeight}>
      <div className="column large-4 small-12 logo-section">
        <div className="logo-section__chachan">Chachan & Lath</div>
        <div className="logo-section__charted">Chartered Accountants</div>
      </div>
      <nav className="medium-expanded small-12 column">
        <ul className="main-menu">
          <li><NavLink  exact={true} activeClassName="active" to="/">Home</NavLink></li>
          <li><NavLink activeClassName="active" to="/about">About</NavLink></li>
          <li><NavLink activeClassName="active" to="/team">Our Team</NavLink></li>
          <li><NavLink activeClassName="active" to="/services">Services</NavLink></li>
          <li><NavLink activeClassName="active" to="/newsCentre">Important Links</NavLink></li>
          <li><NavLink activeClassName="active" to="/contact">Contact Us</NavLink></li>
        </ul>
      </nav>
    </TopFixedMenu>
  </div>
);
export default MainMenu;



// WEBPACK FOOTER //
// ./src/components/MainMenu.js